import Fuse from 'fuse.js';

/**
 * An MUI Autocomplete filterOptions that ranks options with Fuse on what's typed, or keeps
 * every option when nothing is. ResponsiveAutocomplete's optionLimit still applies on top.
 */
export const fuseFilterOptions = (searchOptions) => (options, { inputValue }) => {
	const search = inputValue.trim();
	if (!search) {
		return options;
	}
	return new Fuse(options, searchOptions).search(search).map((result) => result.item);
};
